import './App.css';
import { router } from "./Pages/index";
import { RouterProvider } from "react-router-dom";
import React from 'react';
import { UserProvider } from './Components/Admin/UserContext/UserContext'; // Ajusta la ruta a tu UserContext

function App() {
  return (
    <UserProvider>
      <RouterProvider router={router} />
    </UserProvider>
  );
}

export default App;